import React from 'react';
import { useTextInput } from '../TextInput/TextInput';
import classNames from 'classnames';

interface ILabelProps {
  children: React.ReactNode;
}

export const Label: React.FC<ILabelProps> = ({ children }) => {
  const { id: htmlFor, isRequired } = useTextInput();

  return (
    <label
      className={classNames('tw-lf-form-input-label tw-grid-area-[label]', {
        'tw-lf-label-required': isRequired,
      })}
      htmlFor={htmlFor}
    >
      {children}
    </label>
  );
};
